import { __decorate } from "tslib";
import MDCLinearProgressFoundation from '@material/linear-progress/foundation.js';
import { BaseElement } from '@material/mwc-base/base-element.js';
import { observer } from '@material/mwc-base/observer.js';
import { html, internalProperty, property, query } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map.js';
import { styleMap } from 'lit-html/directives/style-map.js';
/** @soyCompatible */
export class LinearProgressBase extends BaseElement {
    constructor() {
        super(...arguments);
        this.mdcFoundationClass = MDCLinearProgressFoundation;
        this.indeterminate = false;
        this.progress = 0;
        this.buffer = 1;
        this.reverse = false;
        this.closed = false;
        this.ariaLabel = '';
        this.bufferFlexBasisValue = '';
        this.primaryTransformValue = '';
    }
    /**
     * @soyCompatible
     */
    render() {
        /** @classMap */
        const classes = {
            'mdc-linear-progress--closed': this.closed,
            'mdc-linear-progress--indeterminate': this.indeterminate,
            'mdc-linear-progress--reversed': this.reverse,
        };
        const bufferBarStyles = {
            'flex-basis': this.bufferFlexBasisValue,
        };
        const primaryBarStyles = {
            transform: this.primaryTransformValue,
        };
        return html `
      <div
          role="progressbar"
          class="mdc-linear-progress ${classMap(classes)}"
          aria-label="${this.ariaLabel}"
          aria-valuemin="0"
          aria-valuemax="1"
          aria-valuenow="0">
        <div class="mdc-linear-progress__buffer">
          <div
            class="mdc-linear-progress__buffer-bar"
            style=${styleMap(bufferBarStyles)}>
          </div>
          <div class="mdc-linear-progress__buffer-dots"></div>
        </div>
        <div
            class="mdc-linear-progress__bar mdc-linear-progress__primary-bar"
            style=${styleMap(primaryBarStyles)}>
          <span class="mdc-linear-progress__bar-inner"></span>
        </div>
        <div class="mdc-linear-progress__bar mdc-linear-progress__secondary-bar">
          <span class="mdc-linear-progress__bar-inner"></span>
        </div>
      </div>`;
    }
    createAdapter() {
        return {
            addClass: () => undefined,
            removeClass: () => undefined,
            hasClass: (name) => {
                return this.mdcRoot.classList.contains(name);
            },
            forceLayout: () => this.mdcRoot.offsetWidth,
            removeAttribute: (name) => {
                this.mdcRoot.removeAttribute(name);
            },
            setAttribute: (name, value) => {
                this.mdcRoot.setAttribute(name, value);
            },
            setBufferBarStyle: (_property, value) => {
                this.bufferFlexBasisValue = value;
            },
            setPrimaryBarStyle: (_property, value) => {
                this.primaryTransformValue = value;
            },
        };
    }
    open() {
        this.closed = false;
    }
    close() {
        this.closed = true;
    }
}
__decorate([
    query('.mdc-linear-progress')
], LinearProgressBase.prototype, "mdcRoot", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    observer(function (value) {
        this.mdcFoundation.setDeterminate(!value);
    })
], LinearProgressBase.prototype, "indeterminate", void 0);
__decorate([
    property({ type: Number }),
    observer(function (value) {
        this.mdcFoundation.setProgress(value);
    })
], LinearProgressBase.prototype, "progress", void 0);
__decorate([
    property({ type: Number }),
    observer(function (value) {
        this.mdcFoundation.setBuffer(value);
    })
], LinearProgressBase.prototype, "buffer", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    observer(function (value) {
        this.mdcFoundation.setReverse(value);
    })
], LinearProgressBase.prototype, "reverse", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], LinearProgressBase.prototype, "closed", void 0);
__decorate([
    property()
], LinearProgressBase.prototype, "ariaLabel", void 0);
__decorate([
    internalProperty()
], LinearProgressBase.prototype, "bufferFlexBasisValue", void 0);
__decorate([
    internalProperty()
], LinearProgressBase.prototype, "primaryTransformValue", void 0);
//# sourceMappingURL=mwc-linear-progress-base.js.map